import { render } from "./HomePage.vue?vue&type=template&id=5f79c3ac"
const script = {}
script.render = render

export default script